var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 18,
    viewBox: "0 0 25 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9053 8.90019L11.0315 11.9557C10.8018 12.0868 10 11.9114 10 11.6363V5.36407C10 5.08529 10.8082 4.9099 11.0374 5.04837L16.6505 8.26447C16.8855 8.40602 17.1433 8.76418 16.9053 8.90019ZM25 5.75135C25 2.575 22.5531 0 19.5341 0H5.4659C2.44754 0 0 2.575 0 5.75135V12.248C0 15.4243 2.44754 18 5.4659 18H19.5341C22.5531 18 25 15.4243 25 12.248V5.75135Z",
    fill: "#767676"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.d2ca3155f500fdfe9cb13adbe92e736b.svg";
export { ForwardRef as ReactComponent };